import {Box, Button, LinearProgress, Stack} from "@mui/material";
import {DataGrid, itIT} from "@mui/x-data-grid";
import CustomGridToolbar from "../../components/data-grid/CustomGridToolbar";
import React, {useMemo, useState} from "react";
import useAxios from "axios-hooks";
import UserService from "../../services/user.service";
import {useNavigate, useParams} from "react-router-dom";
import ColumnsService from "../../services/columns.service";
import {useAuthStore} from "../../stores/AuthStore";
import {sticketTheme} from "../../theme/sticketTheme";
import MealsSummary from "./MealsSummary";
import {Add, OpenInNew, Visibility} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CustomTooltip from "../../components/CustomTooltip";
import UserDetailsDialog from "./UserDetailsDialog";

const MealsDashboard = () => {
    document.body.style.backgroundColor = sticketTheme.palette.background.default;

    const {tour_id} = useParams()

    const authState = useAuthStore.getState()
    //console.log("authState:", authState)

    const navigate = useNavigate()

    /*const [{data: users, loading: loadingUsers, error: errorUsers}, fetchUsers] = useAxios(
        UserService.usersUrl(tour_id), {method: "GET", useCache: false, manual: false}
    )*/
    //console.log("users:", users)

    return <Stack>
        <MealsSummary viewMode={'grid'}/>
    </Stack>;
}

export default MealsDashboard